import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Caret from 'shared-vectors/icons/Caret';
import Publish from 'shared-vectors/icons/Publish';
import Avatar from 'shared-vectors/icons/Avatar';
import { Icon } from 'shared-vectors';

import getExtPath from 'shared-utils/src/getExtPath';
import createStyle from 'shared-utils/src/createStyle';
import makeClassName from 'shared-utils/src/makeClassName';
import trackGTMEvents from 'shared-utils/src/trackGTMEvents/new';

import casaClaim from 'shared-constants/src/header_footer/casaClaim';

import styles, { mainCls } from './style';

import Button from '../Button';
import Hamburger from '../Hamburger';
import Grid from '../Grid';

const useStyles = createStyle(styles);

const propTypes = {
  hasShadow: PropTypes.bool,
  isTransparent: PropTypes.bool,
  isFixed: PropTypes.bool,
  isHidden: PropTypes.bool,
  isHiding: PropTypes.bool,
  hidePublish: PropTypes.bool,
  logIn: PropTypes.func,
  user: PropTypes.instanceOf(Object),
  toggleNav: PropTypes.func,
  isNavOpen: PropTypes.bool,
  toggleMenu: PropTypes.func,
  backButton: PropTypes.instanceOf(Object),
  noLoginModal: PropTypes.bool,
  noMycasamenu: PropTypes.bool,
  portalDomain: PropTypes.string.isRequired,
  accountDomain: PropTypes.string.isRequired,
  authBasePrefix: PropTypes.string,
  myCasaDomain: PropTypes.string.isRequired,
  fromPortal: PropTypes.bool,
  authBasePrefix: PropTypes.string,
};
const defaultProps = {
  hasShadow: false,
  isTransparent: false,
  isFixed: false,
  isHidden: false,
  isHiding: false,
  hidePublish: false,
  logIn: () => {},
  user: null,
  toggleNav: () => {},
  isNavOpen: false,
  toggleMenu: () => {},
  backButton: null,
  noLoginModal: false,
  noMycasamenu: false,
  fromPortal: false,
  authBasePrefix: '/my',
};

const Header = ({
  hasShadow,
  isTransparent,
  isFixed,
  isHidden,
  isHiding,
  hidePublish,
  logIn,
  user,
  toggleNav,
  isNavOpen,
  toggleMenu,
  backButton,
  noLoginModal,
  noMycasamenu,
  portalDomain,
  accountDomain,
  authBasePrefix,
  myCasaDomain,
  fromPortal,
}) => {
  /** Desktop: animazione della voce Menù coordinata con apertura/chiusura Navigation */
  const [hasNavBeenOpened, setIsNavBeenOpened] = useState(false);
  const [isNavClosing, setIsNavClosing] = useState(false);
  useEffect(
    () => {
      if (!isNavOpen) {
        setIsNavClosing(true);
        setTimeout(() => setIsNavClosing(false), 301);
      } else if (!hasNavBeenOpened) {
        setIsNavBeenOpened(true);
      }
    }, [isNavOpen],
  );
  /** /Desktop: animazione della voce Menù coordinata con apertura/chiusura Navigation */

  const baseUrl = fromPortal
    ? '/'
    : `${portalDomain}/`;

  const pubblicaAnnunci = () => {
    trackGTMEvents({
      category: 'Interaction',
      action: 'GoToInsertAdsPage',
      label: 'MenuTextButton',
    });
    document.location = user && user.isAuthenticated
      ? `${myCasaDomain}/pubblica/annunci`
      : `${baseUrl}pubblica-annunci`;
  };
  const myCasaBtnAction = () => {
    if (noMycasamenu) {
      document.location = `${accountDomain}${authBasePrefix}/login`;
    } else if (user && user.isAuthenticated) {
      toggleMenu();
    } else if (noLoginModal) {
        document.location = `${accountDomain}${authBasePrefix}/login`;      
    } else {
      logIn(null, 'DefaultLogin');
    }
  };

  const cls = useStyles();
  const ctnCls = makeClassName([
    cls[mainCls],
    hasShadow && cls[`${mainCls}--sdw`],
    isTransparent && cls[`${mainCls}--trs`],
    isFixed && cls[`${mainCls}--fix`],
    isHidden && cls[`${mainCls}--hid`],
    isHiding && cls[`${mainCls}--hiding`],
  ]);
  const lnkCls = makeClassName([
    cls[`${mainCls}__btn--txt`],
    'ml--s',
    'tp-w--m',
    'tp-s--s',
    isTransparent ? 'c-txt--w tras' : 'c-txt--secondary',    
  ]);
  const lnkMenuCls = makeClassName([
    cls[`${mainCls}__btn--txt`],
    'ml--s',
    'tp-w--m',
    'tp-s--s',
    isTransparent ? 'c-txt--w tras' : 'c-txt--secondary',  
    (isNavOpen || isNavClosing) && hasNavBeenOpened && cls[`${mainCls}__btn--txt--hid`],
  ]);
  const lnkPubCls = makeClassName([
    cls[`${mainCls}__btn--txt`],
    'ml--xs',
    'tp-w--m',
    'tp-s--s',
    isTransparent ? 'c-txt--w tras' : 'c-txt--secondary',    
  ]);    
  
  return (
    <header className={ctnCls}>
      {
        backButton
          ? (
            <Button
              type="button"
              className={`${cls[`${mainCls}__menu`]} ${cls[`${mainCls}__btn`]}`}
              bg="0"
              size=""
              color={isTransparent ? 'w' : 'secondary'}
              action={backButton.uri}
              aria-label="Torna ai tuoi annunci"
              title="Torna ai tuoi annunci"
            >
              <Icon name={Caret} width="16px" height="16px" className={cls[`${mainCls}__back--icon`]} />
              <span className={lnkMenuCls}>{backButton.txt}</span>
            </Button>
          ) : (
            <Button
              type="button"
              className={`${cls[`${mainCls}__menu`]} ${cls[`${mainCls}__btn`]}`}
              bg="0"
              size=""
              color={isTransparent ? 'w' : 'secondary'}
              action={toggleNav}
              aria-label="Menù"
              title="Menù"
            >
              <Hamburger isOpen={isNavOpen} />
              <span className={lnkMenuCls}>Menu</span>
            </Button>
          )
      }
      <a
        href={baseUrl}
        title={casaClaim}
        className={cls[`${mainCls}__logo`]}
      >
        <img src={getExtPath('common_images/header/casalogo2024.svg')} width="121" height="42" alt={casaClaim} />
      </a>
      <div className={cls[`${mainCls}__utils`]}>
        {
          !!!hidePublish
            && (
              <Button
                type="button"
                className={`${cls[`${mainCls}__pub`]} ${cls[`${mainCls}__btn`]} mr--l`}
                bg="0"
                size=""
                color={isTransparent ? 'w' : 'secondary'}
                action={pubblicaAnnunci}
                aria-label="Pubblica annunci gratis"
                title="Pubblica annunci gratis"
              >
                <Icon name={Publish} width="40px" height="40px" />
                <span className={lnkPubCls}>Pubblica annuncio gratis</span>
              </Button>
            )
        }
        <Button
          type="button"
          className={`${cls[`${mainCls}__my`]} ${cls[`${mainCls}__btn`]}${user && user.isAuthenticated ? ' auth' : ''}`}
          bg="0"
          size=""
          color={isTransparent ? 'w' : 'secondary'}
          aria-label="Accedi a MyCasa"
          title="Accedi a MyCasa"
          action={myCasaBtnAction}
        >
          {
            user && user.isAuthenticated
              ? (
                <Grid data-clarity-mask="True">
                  <span className={cls[`${mainCls}__my--authusr`]} />
                  <span className={lnkCls} data-clarity-mask="True">{user.displayName || user.displayname}</span>
                </Grid>
              ) : (
                <>
                  <Icon name={Avatar} className={cls[`${mainCls}__my--icon`]} />
                  <span className={lnkCls}>Accedi a MyCasa</span>
                </>
              )
          }
        </Button>
      </div>
    </header>
  );
};
Header.propTypes = propTypes;
Header.defaultProps = defaultProps;
export default Header;
